module.exports = __webpack_public_path__ + "media/images/emblems/Aeugst_am_Albis-blazon-89c8c3644f8e115b7d04a35be0f49b7b.svg";